import { Component, OnInit } from '@angular/core';
import { ImportService } from '../../../services/import.service';
import { Router } from '@angular/router';
import { ImportProMappedHeadersProfile } from 'src/app/shared/models/import-pro-mapped-headers-profile';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-ready-to-map',
  templateUrl: './ready-to-map.component.html',
  styleUrls: ['./ready-to-map.component.scss']
})
export class ReadyToMapComponent implements OnInit {

  showReadyToMap = false;

  importType: string;
  importYear: number;
  importQuarter: string;

  importedDate: string;
  importerName: string;

  importTypeSubscription;
  importYearSubscription;
  importQuarterSubscription;

  importProMappedHeadersProfile: ImportProMappedHeadersProfile;

  private _subscriptions = new Subscription();

  constructor(private importService: ImportService, private router: Router) { }

  ngOnInit() {

    this.importTypeSubscription = this.importService.importType$.subscribe((x) => {
      this.importType = x;
    });

    this.importYearSubscription = this.importService.importYear$.subscribe((x) => {
      this.importYear = x;
    });

    this.importQuarterSubscription = this.importService.importQuarter$.subscribe((x) => {
      this.importQuarter = x;
    });

    this.importService.showReadyToMap$.subscribe((x) => {
      this.showReadyToMap = x;
    });

    this.importService.importedDate$.subscribe((x) => {
      this.importedDate = x;
    });

    this.importService.importerName$.subscribe((x) => {
      this.importerName = x;
    });

    this.importService.importProMappedHeadersProfile$.subscribe((x) => {
      this.importProMappedHeadersProfile = x;
    });

    this._subscriptions.add(this.importTypeSubscription)
    this._subscriptions.add(this.importYearSubscription)
    this._subscriptions.add(this.importQuarterSubscription)


  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }

  
  /**
   * Begins the data mapping process
   */
  beginDataMapping(){
    //navigates to partner-group-show-mapper.component
    this.importService.setBreadCrumbActiveStep(2);

    // this.router.navigate(['data/pro/partner-group-show-mapper'], {
    //   queryParams: { profileId: this.importProMappedHeadersProfile.id }
    // });
    this.router.navigate(['data/pro/show-mapper'], {
      queryParams: { profileId: this.importProMappedHeadersProfile.id }
    });
    
  }

}
